// Falta 1 minuto
import alinegrance from './audios/alinegrance.mp3';
import apaulinhacarlos from './audios/apaulinhacarlos.03.mp4';
import devsakae from './audios/devsakae.mp3';
import lelesakae from './audios/lelesakae.04.mp3';
import LucasHenriqueAbreu from './audios/LucasHenriqueAbreu.01.mp4';
import nataliakoliveira from './audios/nataliakoliveira.01.ogg';
import ThiagoFdaSLopes from './audios/ThiagoFdaSLopes.01.mp3';

const falta1min = [
  lelesakae,
  devsakae,
  alinegrance,
  ThiagoFdaSLopes,
  nataliakoliveira,
  apaulinhacarlos,
  LucasHenriqueAbreu,
];

export default falta1min;
